/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ApiResult } from "./ApiResult";
import {
    ApiResultFromJSON,
    ApiResultFromJSONTyped,
    ApiResultToJSON,
} from "./ApiResult";

/**
 *
 * @export
 * @interface ApiMultipleResult
 */
export interface ApiMultipleResult {
    /**
     *
     * @type {Array<ApiResult>}
     * @memberof ApiMultipleResult
     */
    extras?: Array<ApiResult>;
    /**
     * If non-zero, check Message for the error description
     * @type {number}
     * @memberof ApiMultipleResult
     */
    errorNo?: number;
    /**
     *
     * @type {string}
     * @memberof ApiMultipleResult
     */
    message?: string;
    /**
     *
     * @type {number}
     * @memberof ApiMultipleResult
     */
    identity?: number;
    /**
     *
     * @type {string}
     * @memberof ApiMultipleResult
     */
    identityStr?: string;
}

/**
 * Check if a given object implements the ApiMultipleResult interface.
 */
export function instanceOfApiMultipleResult(
    value: object,
): value is ApiMultipleResult {
    return true;
}

export function ApiMultipleResultFromJSON(json: any): ApiMultipleResult {
    return ApiMultipleResultFromJSONTyped(json, false);
}

export function ApiMultipleResultFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ApiMultipleResult {
    if (json == null) {
        return json;
    }
    return {
        extras:
            json["extras"] == null
                ? undefined
                : (json["extras"] as Array<any>).map(ApiResultFromJSON),
        errorNo: json["errorNo"] == null ? undefined : json["errorNo"],
        message: json["message"] == null ? undefined : json["message"],
        identity: json["identity"] == null ? undefined : json["identity"],
        identityStr:
            json["identityStr"] == null ? undefined : json["identityStr"],
    };
}

export function ApiMultipleResultToJSON(value?: ApiMultipleResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        extras:
            value["extras"] == null
                ? undefined
                : (value["extras"] as Array<any>).map(ApiResultToJSON),
        errorNo: value["errorNo"],
        message: value["message"],
        identity: value["identity"],
        identityStr: value["identityStr"],
    };
}
